export var parseAcceptValue = accept => {
  // Predefined categories for extensions and MIME types
  var imageExtensions = new Set(['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'bmp', 'tif', 'tiff', 'pdf']);
  var videoExtensions = new Set(['mp4', 'mpeg', 'mov', 'webm', 'avi', 'mkv', 'm4v', 'h263']);

  // Initialize result sets to ensure no duplicates
  var imageSet = new Set();
  var videoSet = new Set();
  var fileSet = new Set();

  // Handle empty or invalid input
  if (!accept || typeof accept !== 'string') {
    return {
      image: '',
      video: '',
      files: ''
    };
  }

  // Normalize and split the accept string
  var acceptList = accept.split(',').map(type => type.trim().toLowerCase());

  // Use forEach instead of for...of
  acceptList.forEach(type => {
    if (type.startsWith('.')) {
      // Extension case: Remove the leading dot
      var ext = type.slice(1).toLowerCase();
      if (imageExtensions.has(ext)) {
        imageSet.add(ext.toUpperCase());
      } else if (videoExtensions.has(ext)) {
        videoSet.add(ext.toUpperCase());
      } else {
        fileSet.add(ext.toUpperCase());
      }
    } else if (type.includes('/')) {
      // MIME type case: Extract the extension-like part
      var mimeExtension = type.split('/')[1];
      if (imageExtensions.has(mimeExtension)) {
        imageSet.add(mimeExtension.toUpperCase());
      } else if (videoExtensions.has(mimeExtension)) {
        videoSet.add(mimeExtension.toUpperCase());
      } else {
        fileSet.add(mimeExtension.toUpperCase());
      }
    }
  });

  // Convert sets to comma-separated strings
  return {
    image: Array.from(imageSet).join(', '),
    video: Array.from(videoSet).join(', '),
    files: Array.from(fileSet).join(', ')
  };
};
export var getSizeStyles = fieldSize => {
  var sizeStyles = "\n    min-height: var(--spacing-4);\n    font: var(--body-text-x-small);\n  ";
  if (fieldSize === 'large') {
    sizeStyles = "\n      min-height: var(--spacing-8);\n      font: var(--body-text-medium);\n    ";
  }
  if (fieldSize === 'medium') {
    sizeStyles = "\n      min-height: var(--spacing-6);\n      font: var(--body-text-small);\n    ";
  }
  return sizeStyles;
};
export var getFieldPadding = fieldSize => {
  var previewImage = 30;
  var left = 15;
  var right = 15;
  var vertical = 4;
  var imagePadding = 2;
  if (fieldSize === 'small') {
    previewImage = 16;
    left = 9;
    right = 9;
    vertical = 1;
    imagePadding = 2;
  }
  if (fieldSize === 'large') {
    previewImage = 36;
    left = 18;
    right = 18;
    vertical = 9;
    imagePadding = 5;
  }

  // left + 6?

  return {
    left: "".concat(left, "px"),
    right: "".concat(right, "px"),
    previewImage: "".concat(previewImage, "px"),
    imagePadding: "".concat(imagePadding, "px"),
    all: "".concat(vertical, "px ").concat(right, "px ").concat(vertical, "px ").concat(left, "px")
  };
};